'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjsr_AnonFunction1() {
}
export { $c_sjsr_AnonFunction1 as $c_sjsr_AnonFunction1 };
$p = $c_sjsr_AnonFunction1.prototype = new $j_java$002elang$002e$002dObject.$h_sr_AbstractFunction1();
$p.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
}
export { $h_sjsr_AnonFunction1 as $h_sjsr_AnonFunction1 };
$h_sjsr_AnonFunction1.prototype = $p;
